
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iaA9H", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6xdDU = parcelRequire("6xdDU");


var $jyA9t = parcelRequire("jyA9t");


var $9wGTI = parcelRequire("9wGTI");








var $dPJCf = parcelRequire("dPJCf");





var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");

const $21c7cbbeb9139432$var$useOpenCreateParam = (0, $dPJCf.createSingleQueryParamHook)('openCreateWithRovo');
const $21c7cbbeb9139432$export$ac35bf268bbde701 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const [hasSeen, setHasSeen] = (0, $42omo.useState)(false);
    const shouldOpenCreate = $21c7cbbeb9139432$var$useOpenCreateParam();
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('aifc_create_enabled') || !isRovoLLMEnabled || !isLicensed) return;
        if (shouldOpenCreate === 'true' || shouldOpenCreate === 'atlassianNew') {
            const entryPoint = 'queryParam';
            const entryPointToAppend = shouldOpenCreate === 'true' ? '' : `-${shouldOpenCreate}`;
            openModal({
                entryPoint: entryPoint + entryPointToAppend,
                spaceKey: ''
            });
            if (!hasSeen) {
                setHasSeen(true);
                // Clear query params after user has seen modal
                setQueryParams({
                    openCreateWithRovo: null
                });
            }
        }
    }, [
        shouldOpenCreate,
        setQueryParams,
        openModal,
        hasSeen,
        isRovoLLMEnabled,
        isLicensed
    ]);
};



var $2PxwR = parcelRequire("2PxwR");

const $3126d59183e0aea0$var$ConfluenceSmartCreationModalManagerRenderer = ()=>{
    const [{ showSmartCreationModal: showSmartCreationModal }] = (0, $jyA9t.useSmartCreationModalStore)();
    (0, $21c7cbbeb9139432$export$ac35bf268bbde701)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, showSmartCreationModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2PxwR.LazyConfluenceSmartCreationModal), null));
};
const $3126d59183e0aea0$export$bfc0cd6d101c0d9c = ()=>{
    if (!(0, $9wGTI.fg)('aifc_create_enabled')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3126d59183e0aea0$var$ConfluenceSmartCreationModalManagerRenderer, null);
};
module.exports["ConfluenceSmartCreationModalManager"] = $3126d59183e0aea0$export$bfc0cd6d101c0d9c;

});

parcelRegister("2PxwR", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c156286aa1d634b0$export$116ded32e65c3603 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4mwBk",
    name: "LazyConfluenceSmartCreationModal",
    loader: async ()=>(await (parcelRequire("eODZB"))).ConfluenceSmartCreationModal
});
module.exports["LazyConfluenceSmartCreationModal"] = $c156286aa1d634b0$export$116ded32e65c3603;

});

parcelRegister("eODZB", function(module, exports) {

let $ac94c1e697f076e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ac94c1e697f076e6$var$load("h3ABO"),
    $ac94c1e697f076e6$var$load("a7PxR"),
    $ac94c1e697f076e6$var$load("9fvYm"),
    $ac94c1e697f076e6$var$load("im1Yv"),
    $ac94c1e697f076e6$var$load("2vAWg"),
    $ac94c1e697f076e6$var$load("7cABH"),
    $ac94c1e697f076e6$var$load("4UuEP"),
    $ac94c1e697f076e6$var$load("cJcjb"),
    $ac94c1e697f076e6$var$load("9CYct"),
    $ac94c1e697f076e6$var$load("iqTGf"),
    $ac94c1e697f076e6$var$load("8hNVx"),
    $ac94c1e697f076e6$var$load("7do1E"),
    $ac94c1e697f076e6$var$load("77dkW"),
    $ac94c1e697f076e6$var$load("2YffH"),
    $ac94c1e697f076e6$var$load("a7nvi"),
    $ac94c1e697f076e6$var$load("aLflZ"),
    $ac94c1e697f076e6$var$load("9Sp67"),
    $ac94c1e697f076e6$var$load("5aIsS"),
    $ac94c1e697f076e6$var$load("iIoyG"),
    $ac94c1e697f076e6$var$load("2xn4F"),
    $ac94c1e697f076e6$var$load("1P7J4"),
    $ac94c1e697f076e6$var$load("i1up4"),
    $ac94c1e697f076e6$var$load("fJtJG"),
    $ac94c1e697f076e6$var$load("1GvGi"),
    $ac94c1e697f076e6$var$load("d4u0p"),
    $ac94c1e697f076e6$var$load("cksku"),
    $ac94c1e697f076e6$var$load("bogQM"),
    $ac94c1e697f076e6$var$load("jq3Ai"),
    $ac94c1e697f076e6$var$load("bv7z8"),
    $ac94c1e697f076e6$var$load("aNhGE"),
    $ac94c1e697f076e6$var$load("kgDUw"),
    $ac94c1e697f076e6$var$load("eBY1U"),
    $ac94c1e697f076e6$var$load("dUz9k"),
    $ac94c1e697f076e6$var$load("cyGuT"),
    $ac94c1e697f076e6$var$load("dHMdi"),
    $ac94c1e697f076e6$var$load("lId0W"),
    $ac94c1e697f076e6$var$load("3EXzu"),
    $ac94c1e697f076e6$var$load("8pDNY"),
    $ac94c1e697f076e6$var$load("b2FtX"),
    $ac94c1e697f076e6$var$load("e4wOQ"),
    $ac94c1e697f076e6$var$load("3w411"),
    $ac94c1e697f076e6$var$load("fSobj"),
    $ac94c1e697f076e6$var$load("74u2y"),
    $ac94c1e697f076e6$var$load("7oiUM"),
    $ac94c1e697f076e6$var$load("8t3po"),
    $ac94c1e697f076e6$var$load("855o0"),
    $ac94c1e697f076e6$var$load("8MfZE"),
    $ac94c1e697f076e6$var$load("kjZZD"),
    $ac94c1e697f076e6$var$load("bkc7o"),
    $ac94c1e697f076e6$var$load("2wlUS"),
    $ac94c1e697f076e6$var$load("9u7sS"),
    $ac94c1e697f076e6$var$load("1fem1"),
    $ac94c1e697f076e6$var$load("gusn7"),
    $ac94c1e697f076e6$var$load("6wr18"),
    $ac94c1e697f076e6$var$load("ffEVr"),
    $ac94c1e697f076e6$var$load("Wowvf"),
    $ac94c1e697f076e6$var$load("hhss7"),
    $ac94c1e697f076e6$var$load("dAdaw"),
    $ac94c1e697f076e6$var$load("c0JsV"),
    $ac94c1e697f076e6$var$load("1FeuN"),
    $ac94c1e697f076e6$var$load("lrSMb"),
    $ac94c1e697f076e6$var$load("bgHzk"),
    $ac94c1e697f076e6$var$load("7EorR"),
    $ac94c1e697f076e6$var$load("fQKYr")
]).then(()=>parcelRequire('6CLTo'));

});


//# sourceMappingURL=ConfluenceSmartCreationModalManager.f1944e65.js.map
